import { LANDING_PAGE_TYPES } from 'constants/index';
import { uploadThunk } from 'store/assets/thunks';

export const openUploadModal = (
  dispatch,
  { suggested, isOwner, isItinerariesItem, itinerariesItemType, landingPageType, ...settings },
) => {
  const type = settings.type || 'media';
  const s = (media, document) => (type === 'media' ? media : document);

  const libraryName = s('Media', 'Document') + ' Library';
  const singleObject = s('Photo', 'Document');
  const realObject = singleObject + (settings.multiple ? 's' : '');

  const defaults = {
    ...(settings.defaults || {}),
  };
  if (type === 'media') {
    defaults.publiclyAvailable = !isOwner;
  }

  const getPageName = () => {
    if (isItinerariesItem) {
      if (landingPageType === LANDING_PAGE_TYPES.COVER_PAGE) return 'Cover Page';
      return suggested?.headline;
    }
    return suggested?.name;
  };

  return dispatch(
    uploadThunk({
      type,
      pageId: suggested?.id,
      pageName: getPageName(),
      modalTitle: `Add New ${realObject}`,
      searchPlaceholder: `Search ${libraryName}`,
      dropZonePlaceholder: `Upload ${realObject} here.`,
      selectedText: `Successfully Added ${realObject}`,
      selectedTextMultiple: `Successfully Added ${realObject}`,
      notFoundText: `No ${singleObject}s Found. Please try again.`,
      multiple: true,
      isSelectedEnabled: true,
      isSuggestedEnabled: Boolean(suggested),
      isSearchEnabled: true,
      isSortingEnabled: false,
      isItinerariesItem,
      itinerariesItemType,
      landingPageType,
      ...settings,
      defaults,
    }),
  );
};
